/* global axios */
import ApiClient from './ApiClient';

class UisAPI extends ApiClient {
  constructor() {
    super('uis', { accountScoped: true });
  }

  // Current agent's SIP-line credentials for the browser softphone (vivaPhone).
  sipCredentials() {
    return axios.get(`${this.url}/sip_credentials`);
  }

  // Wizard: check an API key before the channel exists.
  validateKey(apiKey) {
    return axios.post(`${this.url}/validate_key`, { api_key: apiKey });
  }

  diagnostics(inboxId) {
    return axios.get(`${this.url}/inboxes/${inboxId}/diagnostics`);
  }

  directory(inboxId) {
    return axios.get(`${this.url}/inboxes/${inboxId}/directory`);
  }

  agents(inboxId) {
    return axios.get(`${this.url}/inboxes/${inboxId}/agents`);
  }

  updateAgent(inboxId, payload) {
    return axios.post(`${this.url}/inboxes/${inboxId}/agents`, payload);
  }

  deleteAgent(inboxId, userId) {
    return axios.delete(`${this.url}/inboxes/${inboxId}/agents/${userId}`);
  }

  webhookStatus(inboxId) {
    return axios.get(`${this.url}/inboxes/${inboxId}/webhook_status`);
  }
}

export default new UisAPI();
